<ng-template #singleAirlineToggle>
    @if (singleAirlineFilter) {
        <div class="avia-stopovers-filter__section avia-stopovers-filter__section_toggle avia-single-airline-toggle">
            <div class="avia-stopovers-filter__title">{{ singleAirlineFilter.name }}</div>
            <button type="button"
                    role="switch"
                    class="avia-stopovers-filter__switch"
                    [attr.aria-label]="singleAirlineFilter.name"
                    [attr.aria-checked]="singleAirlineOnly"
                    [disabled]="isAnyAirlineSelected"
                    [class.avia-stopovers-filter__switch_selected]="singleAirlineOnly"
                    (click)="singleAirlineOnly = !singleAirlineOnly">
                <span class="avia-stopovers-filter__switch-thumb"></span>
            </button>
        </div>
    }
    @if (excludeLccFilter) {
        <div class="avia-stopovers-filter__section avia-stopovers-filter__section_toggle avia-single-airline-toggle">
            <div class="avia-stopovers-filter__title">{{ excludeLccFilter.name }}</div>
            <button type="button"
                    role="switch"
                    class="avia-stopovers-filter__switch"
                    [attr.aria-label]="excludeLccFilter.name"
                    [attr.aria-checked]="excludeLcc"
                    [class.avia-stopovers-filter__switch_selected]="excludeLcc"
                    (click)="excludeLcc = !excludeLcc">
                <span class="avia-stopovers-filter__switch-thumb"></span>
            </button>
        </div>
    }
</ng-template>
<div class="hide">
    <div id="ng-modal-avia-filter-sheet-content"
         class="avia-filter-sheet-content"
         [class.avia-filter-sheet-content_all]="isAllFiltersGroupFilter">
        @if (isAllFiltersGroupFilter) {
            <div class="avia-filter-sheet-main-header">
                <button type="button" class="btn-clear avia-filter-sheet-main-button modal2-close">✕</button>
                <div class="avia-filter-sheet-main-title">{{ filterTitle }}</div>
                <button type="button"
                        class="btn-clear avia-filter-sheet-main-button avia-filter-sheet-main-reset"
                        [class.avia-filter-sheet-main-reset_disabled]="!isResetButtonShown"
                        [class.modal2-close]="isResetButtonShown"
                        [disabled]="!isResetButtonShown"
                        (click)="resetCurrentFilter()"
                        aria-label="Сбросить фильтры"></button>
            </div>
        } @else {
            <div class="avia-filter-sheet-handle"></div>
            <div class="avia-filter-sheet-header">
                <div class="avia-filter-sheet-title">{{ filterTitle }}</div>
            </div>
        }

        @if (isAllFiltersGroupFilter) {
            <div class="avia-filter-sheet-body avia-filter-sheet-body_all">
                @if (priceFilter) {
                    <div class="avia-filter-sheet-section avia-filter-sheet-section_card">
                        <div class="avia-filter-sheet-section-title">{{ priceFilterTitle }}</div>
                        <div class="avia-price-filter avia-filter-sheet-card avia-filter-sheet-card_slider">
                            <div class="avia-price-filter__title">{{ priceFilterTitle }}</div>
                            <div class="avia-price-filter__inputs">
                                <label class="avia-price-filter__field">
                                    <span class="avia-price-filter__label">От</span>
                                    <input
                                            class="avia-price-filter__input"
                                            type="text"
                                            inputmode="numeric"
                                            [value]="minPriceInputValue"
                                            (input)="inputMinPrice($event)"
                                            (blur)="changeMinPrice($event)">
                                </label>

                                <label class="avia-price-filter__field">
                                    <span class="avia-price-filter__label">До</span>
                                    <input
                                            class="avia-price-filter__input"
                                            type="text"
                                            inputmode="numeric"
                                            [value]="maxPriceInputValue"
                                            (input)="inputMaxPrice($event)"
                                            (blur)="changeMaxPrice($event)">
                                </label>
                            </div>

                            <div class="avia-price-filter__slider">
                                <ngx-slider
                                        [(value)]="minPriceValue"
                                        [(highValue)]="maxPriceValue"
                                        [options]="priceOptions"
                                        (userChange)="changePriceRange($event)">
                                </ngx-slider>
                            </div>
                        </div>
                    </div>
                }

                @if (airlinesFilter) {
                    <div class="avia-filter-sheet-section avia-filter-sheet-section_card">
                        <div class="avia-filter-sheet-section-title">{{ airlinesFilter?.name }}</div>
                        <div class="avia-airlines-filter avia-filter-sheet-card">
                            <div class="avia-filter-sheet-card-title">{{ airlinesFilter?.name }}</div>
                            <ng-container [ngTemplateOutlet]="singleAirlineToggle"></ng-container>
                            <button type="button"
                                    class="avia-airlines-filter__item"
                                    [class.avia-airlines-filter__item_selected]="isAnyAirlineSelected"
                                    (click)="selectAnyAirline()">
                                <span class="avia-airlines-filter__checkbox"></span>
                                <span class="avia-airlines-filter__name">Любая авиакомпания</span>
                            </button>

                            @for (airline of airlineValues; track airline.filterValue) {
                                <button type="button"
                                        class="avia-airlines-filter__item"
                                        [class.avia-airlines-filter__item_selected]="isAirlineSelected(airline.filterValue)"
                                        (click)="toggleAirline(airline.filterValue)">
                                    <span class="avia-airlines-filter__checkbox"></span>
                                    @if (!isAirlineLogoFallback(airline.filterValue)) {
                                        <img class="avia-airlines-filter__logo"
                                             [src]="getAirlineLogoSrc(airline.filterValue)"
                                             (error)="setAirlineLogoFallback(airline.filterValue)"
                                             alt="">
                                    } @else {
                                        <span class="avia-airlines-filter__name">{{ airline.viewValue }}</span>
                                    }
                                </button>
                            }
                        </div>
                    </div>
                }

                @if (flightTypeFilter) {
                    <div class="avia-filter-sheet-section avia-filter-sheet-section_card">
                        <div class="avia-filter-sheet-section-title">{{ flightTypeFilter?.name }}</div>
                        <div class="avia-airlines-filter avia-filter-sheet-card">
                            <div class="avia-filter-sheet-card-title">{{ flightTypeFilter?.name }}</div>
                            @for (flightType of flightTypeValues; track flightType.filterValue) {
                                <button type="button"
                                        class="avia-airlines-filter__item"
                                        [class.avia-airlines-filter__item_selected]="isFlightTypeSelected(flightType)"
                                        (click)="selectFlightType(flightType)">
                                    <span class="avia-airlines-filter__checkbox"></span>
                                    <span class="avia-airlines-filter__name">{{ flightType.viewValue }}</span>
                                </button>
                            }
                        </div>
                    </div>
                }

                @if (stopsFilter) {
                    <div class="avia-stopovers-filter__section">
                        <div class="avia-stopovers-filter__title">{{ stopsFilter?.name }}</div>
                        <div class="avia-stopovers-filter__options">
                            @for (stops of stopsValues; track stops.filterValue) {
                                <button type="button"
                                        class="avia-stopovers-filter__option"
                                        [class.avia-stopovers-filter__option_selected]="isStopsSelected(stops)"
                                        (click)="selectStops(stops)">
                                    {{ stops.viewValue }}
                                </button>
                            }
                        </div>
                    </div>
                }

                @if (stopoverDurationFilter) {
                    <div class="avia-stopovers-filter__section">
                        <div class="avia-stopovers-filter__title">{{ stopoverDurationFilter?.name }}</div>
                        <div class="avia-stopovers-filter__options avia-stopovers-filter__options_scroll">
                            @for (stopoverDuration of stopoverDurationValues; track stopoverDuration.filterValue) {
                                <button type="button"
                                        class="avia-stopovers-filter__option"
                                        [class.avia-stopovers-filter__option_selected]="isStopoverDurationSelected(stopoverDuration)"
                                        (click)="selectStopoverDuration(stopoverDuration)">
                                    {{ stopoverDuration.viewValue }}
                                </button>
                            }
                        </div>
                    </div>
                }

                @if (withoutNightStopoversFilter) {
                    <div class="avia-stopovers-filter__section avia-stopovers-filter__section_toggle">
                        <div class="avia-stopovers-filter__title">{{ withoutNightStopoversTitle }}</div>
                        <button type="button"
                                class="avia-stopovers-filter__switch"
                                [class.avia-stopovers-filter__switch_selected]="isWithoutNightStopoversSelected"
                                (click)="toggleWithoutNightStopovers()"
                                aria-label="Без ночных пересадок">
                            <span class="avia-stopovers-filter__switch-thumb"></span>
                        </button>
                    </div>
                }

                @if (baggageOnlyFilter) {
                    <div class="avia-stopovers-filter__section avia-stopovers-filter__section_toggle">
                        <div class="avia-stopovers-filter__title">{{ baggageOnlyFilter?.name }}</div>
                        <button type="button"
                                class="avia-stopovers-filter__switch"
                                [class.avia-stopovers-filter__switch_selected]="selectedBaggageOnly === 'true'"
                                (click)="selectBaggageOnly(selectedBaggageOnly === 'true' ? 'false' : 'true')"
                                aria-label="Только с багажом">
                            <span class="avia-stopovers-filter__switch-thumb"></span>
                        </button>
                    </div>
                }

                @if (departureTimeFromOriginFilter) {
                    <div class="avia-time-filter__section avia-filter-sheet-card_slider">
                        <div class="avia-time-filter__header">
                            <div class="avia-time-filter__title">{{ departureTimeFromOriginTitle }}</div>
                            <div class="avia-time-filter__value">{{ departureTimeFromOriginLabel }}</div>
                        </div>
                        <div class="avia-time-filter__slider">
                            <ngx-slider
                                    [(value)]="departureTimeFromOriginValue"
                                    [(highValue)]="departureTimeFromOriginHighValue"
                                    [options]="departureTimeFromOriginOptions"
                                    (userChange)="changeDepartureTimeFromOriginRange($event)">
                            </ngx-slider>
                        </div>
                    </div>
                }

                @if (departureTimeFromDestinationFilter) {
                    <div class="avia-time-filter__section avia-filter-sheet-card_slider">
                        <div class="avia-time-filter__header">
                            <div class="avia-time-filter__title">{{ departureTimeFromDestinationTitle }}</div>
                            <div class="avia-time-filter__value">{{ departureTimeFromDestinationLabel }}</div>
                        </div>
                        <div class="avia-time-filter__slider">
                            <ngx-slider
                                    [(value)]="departureTimeFromDestinationValue"
                                    [(highValue)]="departureTimeFromDestinationHighValue"
                                    [options]="departureTimeFromDestinationOptions"
                                    (userChange)="changeDepartureTimeFromDestinationRange($event)">
                            </ngx-slider>
                        </div>
                    </div>
                }
            </div>
        } @else {
            <div class="avia-filter-sheet-body">
                @if (isPriceFilter) {
                    <div class="avia-price-filter">
                        <div class="avia-price-filter__title">{{ priceFilterTitle }}</div>

                        <div class="avia-price-filter__inputs">
                            <label class="avia-price-filter__field">
                                <span class="avia-price-filter__label">От</span>
                                <input
                                        class="avia-price-filter__input"
                                        type="text"
                                        inputmode="numeric"
                                        [value]="minPriceInputValue"
                                        (input)="inputMinPrice($event)"
                                        (blur)="changeMinPrice($event)">
                            </label>

                            <label class="avia-price-filter__field">
                                <span class="avia-price-filter__label">До</span>
                                <input
                                        class="avia-price-filter__input"
                                        type="text"
                                        inputmode="numeric"
                                        [value]="maxPriceInputValue"
                                        (input)="inputMaxPrice($event)"
                                        (blur)="changeMaxPrice($event)">
                            </label>
                        </div>

                        <div class="avia-price-filter__slider">
                            <ngx-slider
                                    [(value)]="minPriceValue"
                                    [(highValue)]="maxPriceValue"
                                    [options]="priceOptions"
                                    (userChange)="changePriceRange($event)">
                            </ngx-slider>
                        </div>
                    </div>
                }

                @if (isAirlinesFilter) {
                    <ng-container [ngTemplateOutlet]="singleAirlineToggle"></ng-container>
                    <div class="avia-airlines-filter">
                        <button type="button"
                                class="avia-airlines-filter__item"
                                [class.avia-airlines-filter__item_selected]="isAnyAirlineSelected"
                                (click)="selectAnyAirline()">
                            <span class="avia-airlines-filter__checkbox"></span>
                            <span class="avia-airlines-filter__name">Любая авиакомпания</span>
                        </button>

                        @for (airline of airlineValues; track airline.filterValue) {
                            <button type="button"
                                    class="avia-airlines-filter__item"
                                    [class.avia-airlines-filter__item_selected]="isAirlineSelected(airline.filterValue)"
                                    (click)="toggleAirline(airline.filterValue)">
                                <span class="avia-airlines-filter__checkbox"></span>
                                @if (!isAirlineLogoFallback(airline.filterValue)) {
                                    <img class="avia-airlines-filter__logo"
                                         [src]="getAirlineLogoSrc(airline.filterValue)"
                                         (error)="setAirlineLogoFallback(airline.filterValue)"
                                         alt="">
                                } @else {
                                    <span class="avia-airlines-filter__name">{{ airline.viewValue }}</span>
                                }
                            </button>
                        }
                    </div>
                }

                @if (isFlightTypeFilter) {
                    <div class="avia-airlines-filter">
                        @for (flightType of flightTypeValues; track flightType.filterValue) {
                            <button type="button"
                                    class="avia-airlines-filter__item"
                                    [class.avia-airlines-filter__item_selected]="isFlightTypeSelected(flightType)"
                                    (click)="selectFlightType(flightType)">
                                <span class="avia-airlines-filter__checkbox"></span>
                                <span class="avia-airlines-filter__name">{{ flightType.viewValue }}</span>
                            </button>
                        }
                    </div>
                }

                @if (isSortByFilter) {
                    <div class="avia-airlines-filter">
                        @for (sortBy of sortByValues; track sortBy.filterValue) {
                            <button type="button"
                                    class="avia-airlines-filter__item"
                                    [class.avia-airlines-filter__item_selected]="isSortBySelected(sortBy)"
                                    (click)="selectSortBy(sortBy)">
                                <span class="avia-airlines-filter__checkbox"></span>
                                <span class="avia-airlines-filter__name">{{ sortBy.viewValue }}</span>
                            </button>
                        }
                    </div>
                }

                @if (isStopoversGroupFilter) {
                    <div class="avia-stopovers-filter">
                        @if (stopsFilter) {
                            <div class="avia-stopovers-filter__section">
                                <div class="avia-stopovers-filter__title">{{ stopsFilter.name }}</div>
                                <div class="avia-stopovers-filter__options">
                                    @for (stops of stopsValues; track stops.filterValue) {
                                        <button type="button"
                                                class="avia-stopovers-filter__option"
                                                [class.avia-stopovers-filter__option_selected]="isStopsSelected(stops)"
                                                (click)="selectStops(stops)">
                                            {{ stops.viewValue }}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        @if (stopoverDurationFilter) {
                            <div class="avia-stopovers-filter__section">
                                <div class="avia-stopovers-filter__title">{{ stopoverDurationFilter.name }}</div>
                                <div class="avia-stopovers-filter__options avia-stopovers-filter__options_scroll">
                                    @for (stopoverDuration of stopoverDurationValues; track stopoverDuration.filterValue) {
                                        <button type="button"
                                                class="avia-stopovers-filter__option"
                                                [class.avia-stopovers-filter__option_selected]="isStopoverDurationSelected(stopoverDuration)"
                                                (click)="selectStopoverDuration(stopoverDuration)">
                                            {{ stopoverDuration.viewValue }}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        @if (withoutNightStopoversFilter) {
                            <div class="avia-stopovers-filter__section avia-stopovers-filter__section_toggle">
                                <div class="avia-stopovers-filter__title">{{ withoutNightStopoversTitle }}</div>
                                <button type="button"
                                        class="avia-stopovers-filter__switch"
                                        [class.avia-stopovers-filter__switch_selected]="isWithoutNightStopoversSelected"
                                        (click)="toggleWithoutNightStopovers()"
                                        aria-label="Без ночных пересадок">
                                    <span class="avia-stopovers-filter__switch-thumb"></span>
                                </button>
                            </div>
                        }
                    </div>
                }

                @if (isBaggageOnlyFilter) {
                    <div class="avia-airlines-filter">
                        <button type="button"
                                class="avia-airlines-filter__item"
                                [class.avia-airlines-filter__item_selected]="isBaggageOnlySelected('false')"
                                (click)="selectBaggageOnly('false')">
                            <span class="avia-airlines-filter__checkbox"></span>
                            <span class="avia-airlines-filter__name">Нет</span>
                        </button>
                        <button type="button"
                                class="avia-airlines-filter__item"
                                [class.avia-airlines-filter__item_selected]="isBaggageOnlySelected('true')"
                                (click)="selectBaggageOnly('true')">
                            <span class="avia-airlines-filter__checkbox"></span>
                            <span class="avia-airlines-filter__name">Да</span>
                        </button>
                    </div>
                }

                @if (isDepartureTimeGroupFilter) {
                    <div class="avia-time-filter">
                        @if (departureTimeFromOriginFilter) {
                            <div class="avia-time-filter__section">
                                <div class="avia-time-filter__header">
                                    <div class="avia-time-filter__title">{{ departureTimeFromOriginTitle }}</div>
                                    <div class="avia-time-filter__value">{{ departureTimeFromOriginLabel }}</div>
                                </div>
                                <div class="avia-time-filter__slider">
                                    <ngx-slider
                                            [(value)]="departureTimeFromOriginValue"
                                            [(highValue)]="departureTimeFromOriginHighValue"
                                            [options]="departureTimeFromOriginOptions"
                                            (userChange)="changeDepartureTimeFromOriginRange($event)">
                                    </ngx-slider>
                                </div>
                            </div>
                        }

                        @if (departureTimeFromDestinationFilter) {
                            <div class="avia-time-filter__section">
                                <div class="avia-time-filter__header">
                                    <div class="avia-time-filter__title">{{ departureTimeFromDestinationTitle }}</div>
                                    <div class="avia-time-filter__value">{{ departureTimeFromDestinationLabel }}</div>
                                </div>
                                <div class="avia-time-filter__slider">
                                    <ngx-slider
                                            [(value)]="departureTimeFromDestinationValue"
                                            [(highValue)]="departureTimeFromDestinationHighValue"
                                            [options]="departureTimeFromDestinationOptions"
                                            (userChange)="changeDepartureTimeFromDestinationRange($event)">
                                    </ngx-slider>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }

        <div class="avia-filter-sheet-footer" [class.avia-filter-sheet-footer_single]="!isResetButtonShown || isAllFiltersGroupFilter">
            @if (isAllFiltersGroupFilter) {
                <button
                        type="button"
                        class="btn btn-blue avia-filter-sheet-button modal2-close"
                        (click)="applyCurrentFilter()">
                    Показать билеты
                </button>
            } @else {
                @if (isResetButtonShown) {
                    <button
                            type="button"
                            class="btn avia-filter-sheet-button avia-filter-sheet-button_reset modal2-close"
                            (click)="resetCurrentFilter()">
                        Сбросить
                    </button>
                }
                <button
                        type="button"
                        class="btn btn-blue avia-filter-sheet-button modal2-close"
                        (click)="applyCurrentFilter()">
                    Применить
                </button>
            }
        </div>
    </div>
</div>
